/*!
 * @Author: luoob
 * @Date: 2021-01-19 18:31:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-01-19 18:31:00
 * @Instruduction: 机构舆情接口
 */

import { BaseParams } from './index'
import xhr from './xhr/index'

interface IGetCompanyParams {
    query?: string,                   // 搜索机构名/简称/上市代码
    page_index?: number,              // 第几页(默认1)
    page_size?: number                // 每页条数(默认20)
}

interface IGetCompanyDetailParams {
    id: number                        // 机构 id
}

interface IUpdateCompanyInfoParams {
    id: number,                     // 机构id
    name?: string,                   // 机构名称
    short_name?: string,             // 机构名简称
    stock_code?: string,            // 上市代码
    logo?: string,                  // logo链接
    phone?: string,                 // 电话
    email?: string,                 // 邮箱
    official_url?: string,          // 官网
    address?: string,               // 地址
    intro?: string,                 // 介绍
    keywords?: string[],             // 机构关键词(用于匹配新闻)
    tags?: string[]                  // 机构标签
    check?: number
}

interface IGetkeywordFromUserParams {
    status?: number,                // 审核状态 0:待审核 1:通过 2:不通过
    page_index?: number,
    page_size?: number
}

interface IUpdatekeywordStatusParams {
    id: number,                    // 提交记录 id
    status: number                 // 审核状态
}

interface ICompanySettleListParams {
    status?: number,               // 状态 0:审核中 1:通过 2:不通过
    page_index?: number,           // 第几页
    page_size?: number             // 每页条数
}


interface ICompanySettleDetailParams {
    id: number
}



interface IUpdateSettleStatusParams {
    id: number,
    status: number
}

interface ICompanyAuthListParams extends ICompanySettleListParams {}

interface ICompanyAuthDetailParams extends ICompanySettleDetailParams {}

interface IUpdateAuthStatusParams extends IUpdateSettleStatusParams {}

interface IPrCertListParams {
    status?: number,               // 状态 0:审核中 1:通过 2:不通过
    page_index?: number,           // 第几页
    page_size?: number             // 每页条数
}

interface IPrCertDetailParams {
    id: number
}

interface IUpdatePrCertStatusParams {
    id: number,
    status: number
}

interface IEditInfoListParams extends BaseParams {
    status?: number
}

interface IGetEditInfoDetailParams {
    id: number
}

interface IUpdateEditInfoStatusParams {
    id: number
    status: number
}

class EnterpriseService {
    /** 获取机构列表 */
    public async getCompanyList(params: IGetCompanyParams) {
        const result = await xhr({
            method: 'get',
            url: '/company/list',
            params: params
        })
        return result
    }

    /** 获取机构详情 */
    public async getCompanyDetail(params: IGetCompanyDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/company',
            params: params
        })
        return result
    }

    /** 更新机构信息 */
    public async updateCompanyInfo(params: IUpdateCompanyInfoParams) {
        const result = await xhr({
            method: 'put',
            url: '/company',
            params: params
        })
        return result
    }

    /** 创建机构信息 */
    public async createCompany(params: any) {
        const result = await xhr({
            method: 'post',
            url: '/company',
            params: params
        })
        return result
    }

    /** 获取用户提交的机构标签列表 */
    public async getKeywordFromUser(params: IGetkeywordFromUserParams) {
        const result = await xhr({
            method: 'get',
            url: '/company/keywords/list',
            params: params
        })
        return result
    }

    /** 机构标签审核 */
    public async updateKeywordStatus(params: IUpdatekeywordStatusParams) {
        const result = await xhr({
            method: 'put',
            url: '/company/keywords',
            params: params
        })
        return result
    }

    /** 获取机构入驻申请列表 */
    public async getCompanySettleList(params: ICompanySettleListParams) {
        const result = await xhr({
            method: 'get',
            url: '/company/join/list',
            params: params
        })
        return result
    }

    /** 获取机构入驻申请详情 */
    public async getCompanySettleDetail(params: ICompanySettleDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/company/join',
            params: params
        })
        return result
    }

    /** 更新机构入驻申请状态 */
    public async updateCompanySettleStatus(params: IUpdateSettleStatusParams) {
        const result = await xhr({
            method: 'put',
            url: '/company/join',
            params: params
        })
        return result
    }

    /** 获取机构认证申请列表 */
    public async getCompanyAuthList(params: ICompanyAuthListParams) {
        const result = await xhr({
            method: 'get',
            url: '/company/cert/list',
            params: params
        })
        return result
    }

    /** 获取机构认证申请详情 */
    public async getCompanyAuthDetail(params: ICompanyAuthDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/company/cert',
            params: params
        })
        return result
    }

    /** 更新机构入驻申请状态 */
    public async updateCompanyAuthStatus(params: IUpdateAuthStatusParams) {
        const result = await xhr({
            method: 'put',
            url: '/company/cert',
            params: params
        })
        return result
    }

    /** 获取PR认证申请列表 */
    public async getPrCertList(params: IPrCertListParams) {
        const result = await xhr({
            method: 'get',
            url: '/company/pr/cert/list',
            params: params
        })
        return result
    }

    /** 获取PR认证申请详情 */
    public async getPrCertDetail(params: IPrCertDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/company/pr/cert',
            params: params
        })
        return result
    }

    /** 更新PR认证申请状态 */
    public async updatePrCertStatus(params: IUpdatePrCertStatusParams) {
        const result = await xhr({
            method: 'put',
            url: '/company/pr/cert',
            params: params
        })
        return result
    }

    /** 获取机构信息修改申请列表 */
    public async getEditInfoList(params: IEditInfoListParams) {
        const result = await xhr({
            method: 'get',
            url: '/company/update_apply/list',
            params: params
        })
        return result
    }

    /** 机构信息修改申请详情 */
    public async getEditInfoDetail(params: IGetEditInfoDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/company/update_apply',
            params: params
        })
        return result
    }

    /** 机构信息修改申请审核 */
    public async updateEditInfoStatus(params: IUpdateEditInfoStatusParams) {
        const result = await xhr({
            method: 'put',
            url: '/company/update_apply',
            params: params
        })
        return result
    }

    /** 获取机构分类 */
    public async getClassList(params = {}) {
        const result = await xhr({
            method: 'get',
            url: '/company/type/list',
            params: params
        })
        return result
    }

    /** 企业采访列表 */
    public async getInterviewList(params: any) {
        return xhr({
            method: 'get',
            url: '/company/interview/list',
            params: params
        })
    }

    /** 企业采访详情 */
    public async getInterviewDetail(params: any) {
        return xhr({
            method: 'get',
            url: '/company/interview',
            params: params
        })
    }
}

// 实例化后导出，全局单例
export default new EnterpriseService()
